/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ClientDropdown_clients = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly logoId: string | null;
    } | null;
    readonly " $refType": "ClientDropdown_clients";
}>;
export type ClientDropdown_clients$data = ClientDropdown_clients;
export type ClientDropdown_clients$key = ReadonlyArray<{
    readonly " $data"?: ClientDropdown_clients$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ClientDropdown_clients">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ClientDropdown_clients",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Client",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientTypeEdge"
};
(node as any).hash = '7b7436a5a10c6e4fee567fcfc92b395e';
export default node;
